import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MSMEEventEnrollmentModel } from '../../../../../shared/models/MSMEEventEnrollmentModel';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ParticipantListModel } from '../../../../../shared/models/ParticipantListModel';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-enrollnewevent',
  templateUrl: './enrollnewevent.component.html',
  styleUrl: './enrollnewevent.component.css'
})
export class EnrollneweventComponent {
  eventForm: FormGroup;
  participantObj!: ParticipantListModel;
  participantsList: {
      ParticipantName: string;
      Designation: string;
      MobileNumber: string;
      EmailId: string; 
    }[] = [];
  eventId = sessionStorage.getItem("EventId");
  eventObj!: MSMEEventEnrollmentModel;
  msmeUserId = sessionStorage.getItem('msMeUserId');
  msmeUserName = sessionStorage.getItem('msMeUserName');
  isEditMode: boolean = false;
  currentParticipantId: string | null = null;
  disableButton: boolean = false;
  loadingSequence: boolean = false;
  constructor(public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService,
    private toastrService: ToastrService,)
  {
    this.eventForm = this.fb.group({
      participantName: ['', [Validators.pattern(this.commonService.nameWithSpacePattern), Validators.minLength(3),Validators.maxLength(50)]],
      participantDesignation: ['', [Validators.pattern(this.commonService.nameWithSpacePattern), Validators.minLength(3), Validators.maxLength(50)]],
      participantMobile: ['', [Validators.pattern(this.commonService.mobilePattern), Validators.maxLength(10)]],
      participantEmailId: ['', [Validators.pattern(this.commonService.emailPattern), Validators.maxLength(150),]],
    }); 
  }
  get f() {
    return this.eventForm.controls;
  }  

  ngOnInit(): void {
    if (this.eventId) {
      this.LoadDetails(this.eventId);
      this.LoadParticipantsDetails();
    } else {
      this.toastrService.error("Something went wrong");
    }
  }

  LoadDetails(EventId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETEVENTFORENROLLMENT, { EventId }).subscribe(
      (result:MSMEEventEnrollmentModel) => {
        if (result.status) {
          this.eventObj = {
            status: result.status,
            message: result.message,
            list1: result.list1.length > 0 ? [result.list1[0]] : [],
            list2: result.list2,
            list3: result.list3
          };
        }
      }
    );
  }  

  LoadParticipantsDetails() {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETENROLLEDPARTICIPANTLIST, {
      EventId: this.eventId,
      MsMeUserId: this.msmeUserId
    }).subscribe(
      (result: ParticipantListModel) => {
        if (result.status) {
          this.participantObj = {
            status: result.status,
            message: result.message,
            data: result.data
          };
        } 
      }
    );
  }
   
  get participants(): FormArray {
    return this.eventForm.get('participants') as FormArray;
  }
   
  onSubmit(): void {
    this.eventForm.get('participantName')?.markAsTouched();
    this.eventForm.get('participantDesignation')?.markAsTouched();
    this.eventForm.get('participantMobile')?.markAsTouched();
    this.eventForm.get('participantEmailId')?.markAsTouched();

    const EventId = this.eventId;

    if (this.eventForm.valid) {
      const formValues = this.eventForm.value;
      const mobileNumberAsString = formValues.participantMobile.toString().trim();

      const participantData = {
        ParticipantName: formValues.participantName,
        Designation: formValues.participantDesignation,
        MobileNumber: mobileNumberAsString,
        EmailId: formValues.participantEmailId
      };               

      if (this.isEditMode && this.currentParticipantId) {
        const existingParticipant = this.participantObj?.data.find(participant =>
          participant.participantName === participantData.ParticipantName &&
          participant.mobileNumber === participantData.MobileNumber &&
          participant.emailId === participantData.EmailId &&
          participant.designation === participantData.Designation
        );

        if (existingParticipant) {
          this.toastrService.error('This Email or Mobile number already exists.');
          return;
        }
        const dtoUpdateEnrolledParticipant = {
          EnrollmentId: this.currentParticipantId,
          ...participantData
        };
        this.loadingSequence = true;
        this.apiService.postRequest(API_ENDPOINTS.MSME.UPDATEENROLLEDPARTICIPANT, dtoUpdateEnrolledParticipant)
          .subscribe(response => {
            if (response) {
              this.toastrService.success("Participant updated successfully.");
              this.resetForm();
              //window.location.reload();
              if (!this.eventId) {
                //console.error('EventId not found in route');
                return;
              }
              this.LoadDetails(this.eventId);
              this.LoadParticipantsDetails();
              this.eventForm.reset();
              this.loadingSequence = false;
            }
          });
      } else {
        const existingParticipant = this.participantObj?.data.find(participant =>          
          participant.mobileNumber === participantData.MobileNumber ||
          participant.emailId === participantData.EmailId

        );

        if (existingParticipant) {
          this.toastrService.error('This Email or Mobile Number already exists.');
          this.loadingSequence = false;
          return;
        }
        
        this.apiService.getRequest(API_ENDPOINTS.MSME.MSMEALLCHECKSFOREVENTENROLLMENT, { MsmeUserName:this.msmeUserName, EventId: EventId }).subscribe(
          (result) => {
            if (result.status && result.message==='You can enroll new participant.') {
              // If in insert mode, add the new participant
              const saveDto = {
                EventId: this.eventId,
                MsMeUserId: this.msmeUserId,
                EnrolledParticipantsList: [participantData] // Inserting a new participant
              };
              //this.disableButton = true;
              this.loadingSequence = true;
              this.apiService.postRequest(API_ENDPOINTS.MSME.SAVEMSMEPARTICIPANTLIST, saveDto)
                .subscribe(response => {
                  if (response) {
                    this.toastrService.success(response.message);
                    this.disableButton = true;
                    //window.location.reload();
                    if (!this.eventId) {
                      //console.error('EventId not found in route');
                      return;
                    }                    
                    this.LoadDetails(this.eventId);
                    this.LoadParticipantsDetails();
                    this.eventForm.reset();
                    this.loadingSequence = false;
                  }
                   this.disableButton = false;
                });
            } else {              
              this.toastrService.info(result.message);
              this.loadingSequence = false;
              this.resetForm();
            }
          },
          error => {
            this.toastrService.error('API Error:', error);
          }
        );
      }
    } else {
      this.eventForm.markAllAsTouched();
      this.toastrService.error('Please fill all required fields.');
      return;
    }
  }

  updateParticipant(participant: any): void {
    this.isEditMode = true;
    this.currentParticipantId = participant.enrollmentId; // Store EnrollmentId for editing

    // Populate the form with the participant's existing data
    this.eventForm.patchValue({
      participantName: participant.participantName,
      participantDesignation: participant.designation,
      participantEmailId: participant.emailId,
      participantMobile: participant.mobileNumber,
    });
  }


  resetForm(): void {
    this.eventForm.reset();
    this.isEditMode = false;
    this.currentParticipantId = null;
  }
  
  DeleteParticipant(EnrollmentId: string): void {
    this.apiService.postRequest(API_ENDPOINTS.MSME.DELETEENROLLEDPARTICIPANT, { enrollmentId: EnrollmentId })
      .subscribe(response => {
          if (response) {
            this.toastrService.success("Participant deleted successfully.");
            //window.location.reload();
            if (!this.eventId) {
              //console.error('EventId not found in route');
              return;
            }
            this.LoadDetails(this.eventId);
            this.LoadParticipantsDetails();
            this.eventForm.reset();
          }
            
      });
  }


  openConfirmationDialog(index: string): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { index }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.DeleteParticipant(index);
      }
    });
  }

  onPressBack() {
    this.router.navigate(['/vieweventlist']);
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
